import React, { Component } from 'react'



class Comment extends Component {
  render() {
    return (
      <div className="ui inverted segment">
        <div className="ui inverted relaxed divided list">
          <div className="item">
            <div className="content">
              {this.props.children}
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default Comment



// WEBPACK FOOTER //
// ./src/components/Comment.js